// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15ibt","footer":"styles_footer__F0aor","passCodeTooltip":"styles_passCodeTooltip__2sYfF"};